import { Stack } from '@my/ui'
import { SpacerBlock } from './spacer.block'

export const SpacerComponent = (block: SpacerBlock) => {
  return <Stack height={block.adjustment} />
}
